import LeadText from "@material-tailwind/react/LeadText";
import Input from "@material-tailwind/react/Input";
import Button from "@material-tailwind/react/Button";
import { Link } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { Small, Tooltips } from "@material-tailwind/react";
import H5 from "@material-tailwind/react/Heading5";
import { css } from "@emotion/react";
import ClipLoader from "react-spinners/DotLoader";
import TooltipsContent from "@material-tailwind/react/TooltipsContent";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: blue;
`;
export default function Header(props) {
  const InputRef = useRef();
  let [loading, setLoading] = useState(false);
  let [color, setColor] = useState("#ffffff");

  let [text_, settext_] = useState("xxxx");

  useEffect(async () => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch("https://sh2kml4ridealltiles.herokuapp.com/ping", requestOptions)
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  }, []);

  let pos =
    props.positionGlobal1.lat.toFixed(2) +
    "," +
    props.positionGlobal1.lng.toFixed(2);
  let linkVisited = `https://squarehuntersapi.herokuapp.com/Tile.kml?share_link=${props.shLink1}&homeCoordinates=${pos}&visited=1`;
  let linkVisitedText = `https://squarehuntersapi.herokuapp.com/Tile.kml?share_link=${props.shLink1}&homeCoordinates=${pos}&visited=1&astext=1`;

  return (
    <div className="relative pt-16 pb-32 flex content-center items-center justify-center h-screen">
      <div className="bg-landing-background bg-cover bg-center absolute top-0 w-full h-full" />
      <div className="container max-w-8xl relative mx-auto">
        <div className="items-center flex flex-wrap">
          <div className="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
            <H5 color="white">
              Your tiles kml file for
              <a
                href="https://apps.garmin.com/en-US/apps/e53331b6-55db-475a-99e9-3f567327e7ce"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                EveryTile{" "}
              </a>
            </H5>
            <div className="text-gray-200">
              <Small color="gray-200">
                <p>
                  {" "}
                  Get your Statshunters Share Link from ->{" "}
                  <a
                    style={{ color: "white" }}
                    href="https://statshunters.com/share"
                  >
                    {" "}
                    here
                  </a>
                </p>
              </Small>

              <Small style={{ color: "red" }}>
                Warning! Download can take upto 30 seconds due to free service
                layer {text_}
              </Small>
              {props.positionGlobal}
            </div>
            <form
              action="https://squarehuntersapi.herokuapp.com/Tile.kml"
              method="get"
            >
              <div className="items-center flex flex-wrap">
                <Input
                  id="share_link"
                  name="share_link"
                  required
                  // class="text-left
                  style={{ color: "white" }}
                  value={props.shLink1}
                  onChange={(e) => {
                    props.handleCallbackshLink1(e.target.value);
                    // props.handleCallbackshLink1(e.target.value);
                  }}
                  placeholder="SH Share link"
                  outline={true}
                  size="regular"
                  defaultValue="https://statshunters.com/share/28fa9b5675ba"
                />
              </div>
              <div className="flex gap-3 mt-6 mb-4  text-red-800">
                <div class="flex-2">
                  <Input
                    ref={InputRef}
                    id="homeCoordinates"
                    name="homeCoordinates"
                    required
                    style={{ color: "white" }}
                    type="text"
                    placeholder=" Home Cordinates"
                    outline={true}
                    size="sm"
                    // defaultValue={position.lat + ' , ' +position.lng }
                    defaultValue={
                      props.positionGlobal1.lat.toFixed(2) +
                      " , " +
                      props.positionGlobal1.lng.toFixed(2)
                    }
                  />
                  <Tooltips placement="top" ref={InputRef}>
                    <TooltipsContent>Tooltip top</TooltipsContent>
                  </Tooltips>
                </div>
                <div class="flex-1">
                  <Link to="/setLocation">
                    <Button color="lightBlue">Set on map</Button>
                  </Link>
                </div>
              </div>
              {/*<Textarea color="lightBlue" placeholder="Message" />*/}

              <div className="flex justify-center mt-10 mr-2">
                <Button color="lightBlue" ripple="light" className=" mr-2">
                  Get unvisited
                </Button>

                <div>
                  <a href={linkVisited}>
                    <Button
                      // onclick="location.href='https://sh2kml4ridealltiles.herokuapp.com/Tile.kml?share_link=https://statshunters.com/share/28fa9b5675ba&homeCoordinates=51.22,20.22&visited=1'"
                      color="lightGrey"
                      ripple="light"
                      className=" mr-2"
                    >
                      Get visited
                    </Button>
                  </a>
                </div>
              </div>
            </form>
            <ClipLoader
              color={color}
              loading={loading}
              css={override}
              size={55}
            />
            <div className="text-gray-200">
              <LeadText color="gray-200">
                <p>
                  {" "}
                  You can check generated file ->{" "}
                  <a
                    style={{ color: "white" }}
                    href="https://kmlviewer.nsspot.net/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    here
                  </a>
                </p>

                <p>
                  Then you can generate map string for EveryTile ->{" "}
                  <a
                    style={{ color: "white" }}
                    href="http://www.shmo.de/EveryTile/index.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    here
                  </a>
                </p>
                <p>
                  {/*<a style={{color: 'white'}}  href="https://kmlviewer.nsspot.net/" target="_blank"> here</a>*/}
                  {/*<a href='http://statshunters2kml.rx48.eu/Tile.kml?share_link=https://statshunters.com/share/28fa9b5675ba&homeCoordinates=51.402334390659874,20.99668444569511' >Tiles</a>*/}
                </p>
              </LeadText>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
